/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import {
  Box,
  Button,
  Circle,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  SimpleGrid,
  VStack,
  Checkbox,
  FormControl,
  Select,
  Input,
} from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormTextInput } from '@laxmimanogna/code-quick-components';
import React, { useEffect, useRef, useState } from 'react';
import { useFieldArray, useForm, Controller } from 'react-hook-form';

import AppColors from '../../../constants/AppColors';
import { AddIcon } from '../../../constants/IconData';
import { FONT_FAMILY } from '../../../constants/Theme';
import * as yup from 'yup';
import { onlyAlphabetsRegex } from '../../../constants/constants';
import DropdownWithText from './DropdownWithText';

const EditAccountContact = ({
  isOpen,
  onClose,
  onContactChange,
  accountData,
  existingUsers = [], // existingUsers contains: email, first_name, last_name, is_primary, can_upload
  isUpdating = false,
}) => {
  const accountEditSchema = {
    is_primary: yup.bool().required(),
    can_upload: yup.bool().required(),
    parent_spoc: yup.bool(),
    unique_id: yup.string(),
    first_name: yup
      .string()
      .required('First Name is required')
      .matches(onlyAlphabetsRegex, 'Only letters (no edge spaces)'),
    last_name: yup
      .string()
      .required('Last Name is required')
      .matches(onlyAlphabetsRegex, 'Only letters (no edge spaces)'),
    email: yup.string().email("Enter valid email").nullable(),
  };
  
  const [radioValue] = useState('0');
  const createAccountSchema = yup.object({
    account_contact: yup
      .array()
      .of(yup.object(accountEditSchema))
      // .required()
      .min(1),
  });

  const [selectedPrimaryAccountCheckBoxIndex, spacbiState] = useState([]);
  const [selectedCanUploadCheckBoxIndex, setSelectedCanUploadCheckBoxIndex] = useState([]);

  const GRID_SPACING = 5;

  function createNewContact() {
    return {
      first_name: '',
      last_name: '',
      email: '',
      is_primary: false,
      can_upload: true,
      parent_spoc: false,
      unique_id: '',
    };
  }

  const handleCheckBox = (event, index) => {
    let checkedIndexes = [...selectedPrimaryAccountCheckBoxIndex];
    if (event.target.checked) {
      checkedIndexes.push(index.toString());
    } else {
      checkedIndexes = checkedIndexes.filter(d => d !== index.toString());
    }
    spacbiState(checkedIndexes);
  };

  const handleCheckBoxForCanUpload = (event, index) => {
    let checkedIndexes = [...selectedCanUploadCheckBoxIndex];
    if (event.target.checked) {
      checkedIndexes.push(index.toString());
    } else {
      checkedIndexes = checkedIndexes.filter(d => d !== index.toString());
    }
    setSelectedCanUploadCheckBoxIndex(checkedIndexes);
  };

  const [selectedFromDropdown, setSelectedFromDropdown] = useState({});

  // Prepare email options for dropdown
  const emailOptions = existingUsers && Array.isArray(existingUsers) 
    ? existingUsers.map(user => ({
        label: user?.email || user.first_name,
        value: user?.email || '',
        data: user
      }))
    : [];

  const handleEmailChange = (selectedOption, field, index) => {
  if (!selectedOption) {
    field.onChange('');
    setValue(`account_contact.${index}.first_name`, '');
    setValue(`account_contact.${index}.last_name`, '');
    setValue(`account_contact.${index}.parent_spoc`, false);
    setValue(`account_contact.${index}.unique_id`, '');
    setSelectedFromDropdown(prev => ({ ...prev, [index]: false }));
    
    // Clear checkboxes
    spacbiState(prev => prev.filter(d => d !== index.toString()));
    setSelectedCanUploadCheckBoxIndex(prev => prev.filter(d => d !== index.toString()));
    return;
  }

  // Check if it's a custom typed email or selected from list
  const isCustomEmail = typeof selectedOption === 'string' || !selectedOption.data;
  
  if (isCustomEmail) {
    // User typed a custom email - new user
    const emailValue = typeof selectedOption === 'string' ? selectedOption : selectedOption.value;
    field.onChange(emailValue);
    setValue(`account_contact.${index}.parent_spoc`, false); // Not from existing users
    setValue(`account_contact.${index}.unique_id`, '');
    setSelectedFromDropdown(prev => ({ ...prev, [index]: false }));
    
    // Don't change checkboxes for new users - keep current state
  } else {
    // User selected from existing users
    const userData = selectedOption.data;
    field.onChange(userData.email || '');
    setValue(`account_contact.${index}.first_name`, userData.first_name || '');
    setValue(`account_contact.${index}.last_name`, userData.last_name || '');
    setValue(`account_contact.${index}.parent_spoc`, true); // Mark as existing user
    setValue(`account_contact.${index}.unique_id`, userData.unique_id || '');
    setSelectedFromDropdown(prev => ({ ...prev, [index]: true }));

    // Update is_primary checkbox based on existing user data
    const currentPrimary = [...selectedPrimaryAccountCheckBoxIndex];
    if (userData.is_primary) {
      if (!currentPrimary.includes(index.toString())) {
        spacbiState([...currentPrimary, index.toString()]);
      }
    } else {
      spacbiState(currentPrimary.filter(d => d !== index.toString()));
    }

    // Update can_upload checkbox based on existing user data
    const currentCanUpload = [...selectedCanUploadCheckBoxIndex];
    if (userData.can_upload) {
      if (!currentCanUpload.includes(index.toString())) {
        setSelectedCanUploadCheckBoxIndex([...currentCanUpload, index.toString()]);
      }
    } else {
      setSelectedCanUploadCheckBoxIndex(currentCanUpload.filter(d => d !== index.toString()));
    }
  }
};

  const getFieldValue = (field) => {
    if (!field.value) return null;
    
    // Check if the value matches any existing user
    const matchingUser = existingUsers && Array.isArray(existingUsers) 
      ? existingUsers.find(user => user?.email === field.value)
      : null;
    
    if (matchingUser) {
      return {
        label: matchingUser.email,
        value: matchingUser.email,
        data: matchingUser
      };
    }
    
    // Return as custom value
    return {
      label: field.value,
      value: field.value
    };
  };

  const form = useForm({
    resolver: yupResolver(createAccountSchema),
    mode: 'onSubmit',
    defaultValues: {
      account_contact: !accountData?.length
        ? [createNewContact()]
        : accountData,
    },
  });
  const { control, handleSubmit, setValue, getValues, reset, formState: { errors } } = form;
  const contactField = useFieldArray({
    control,
    name: 'account_contact',
  });

  const scrollContainerRef = useRef(null);

  function scrollToBottom() {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
    }
  }

  function submitAddAccount(formData) {
    onContactChange(formData);
  }

  useEffect(() => {
  getValues('account_contact')?.forEach((dt, index) => {
    if (selectedPrimaryAccountCheckBoxIndex.includes(index.toString())) {
      setValue(`account_contact.${index}.is_primary`, true);
    } else {
      setValue(`account_contact.${index}.is_primary`, false);
    }
  });
}, [selectedPrimaryAccountCheckBoxIndex]);

useEffect(() => {
  getValues('account_contact')?.forEach((dt, index) => {
    if (selectedCanUploadCheckBoxIndex.includes(index.toString())) {
      setValue(`account_contact.${index}.can_upload`, true);
    } else {
      setValue(`account_contact.${index}.can_upload`, false);
    }
  });
  scrollToBottom();
}, [selectedCanUploadCheckBoxIndex]);

// 5. Update the initialization useEffect to handle parent_spoc
useEffect(() => {
  if (accountData && accountData.length) {
    reset({ account_contact: accountData });
  }
  let primaryContacts =
    accountData &&
    accountData
      .map((a, i) => (a?.is_primary ? i.toString() : null))
      .filter(index => index !== null);
  primaryContacts && spacbiState([...primaryContacts]);

  let canUploadContacts =
    accountData &&
    accountData
      .map((a, i) => (a?.can_upload ? i.toString() : null))
      .filter(index => index !== null);
  canUploadContacts && setSelectedCanUploadCheckBoxIndex([...canUploadContacts]);

  // Initialize selectedFromDropdown based on parent_spoc
  if (accountData && accountData.length) {
    const dropdownState = {};
    accountData.forEach((contact, index) => {
      dropdownState[index] = contact?.parent_spoc === true;
    });
    setSelectedFromDropdown(dropdownState);
  }
}, [accountData]);

  function renderAddContactForm(field, index) {
    return (
      <React.Fragment key={field.id}>
        <VStack display="block">
          <SimpleGrid
            columns={{ sm: 1, md: 5 }}
            spacing={GRID_SPACING}
            alignItems="flex-start"
            minH="90px"
          >
            {/* Email Field */}
            <Box gridColumn={{ md: 'span 2' }}>
              <Controller
                name={`account_contact.${index}.email`}
                control={control}
                render={({ field: { ref, ...rest }, field }) => (
                  <VStack align="start" width="100%">
                    <DropdownWithText
                      {...rest}
                      options={emailOptions || []}
                      isLoading={emailOptions == null}
                      noOptionsMessage={() =>
                        emailOptions == null ? 'Loading ...' : 'No options available'
                      }
                      onChange={(selectedOption) =>
                        handleEmailChange(selectedOption, field, index)
                      }
                      placeholder="Select/Type Email"
                      value={getFieldValue(field)}
                    />
                    {errors?.account_contact?.[index]?.email && (
                      <Text color="red" fontSize="sm">
                        {errors.account_contact[index].email.message}
                      </Text>
                    )}
                  </VStack>
                )}
              />
            </Box>

            {/* First Name */}
            <FormTextInput
              name={`account_contact.${index}.first_name`}
              control={control}
              placeholder="First Name"
              size="lg"
              isDisabled={selectedFromDropdown[index] === true}
              errorTextStyle={{ fontSize: "14px" }}
              // wrapperProps={{ mb: "20px" }}
            />

            {/* Last Name */}
            <FormTextInput
              name={`account_contact.${index}.last_name`}
              control={control}
              placeholder="Last Name"
              size="lg"
              isDisabled={selectedFromDropdown[index] === true}
              errorTextStyle={{ fontSize: "14px"}}
            />

            {/* Remove Button */}
            {index.toString() !== radioValue ? (
              <Box h="12" display="flex" alignItems="center">
                <Text
                  onClick={() => contactField.remove(index)}
                  cursor="pointer"
                  color={AppColors.secondary}
                  fontSize="sm"
                  _hover={{ textDecoration: 'underline' }}
                  whiteSpace="nowrap"
                >
                  Remove
                </Text>
              </Box>
            ) : (
              <Box />
            )}
          </SimpleGrid>

          {/* Checkboxes Row */}
          <Box display="flex" alignItems="center" gap="2" mt={2}>
            <Checkbox
              onChange={(e) => handleCheckBox(e, index)}
              value={index.toString()}
              defaultChecked={selectedPrimaryAccountCheckBoxIndex.includes(
                index.toString()
              )}
            >
              Primary Account
            </Checkbox>
            <Checkbox
              onChange={(e) => handleCheckBoxForCanUpload(e, index)}
              value={index.toString()}
              defaultChecked={selectedCanUploadCheckBoxIndex.includes(
                index.toString()
              )}
              ml={3}
            >
              Can Upload
            </Checkbox>
          </Box>
        </VStack>
      </React.Fragment>

    );
  }

  function renderAddIcon(_props) {
    return (
      <HStack mt={3} mr={12} mb={5} _hover={{ cursor: 'pointer' }} {..._props}>
        <Text fontSize={'sm'} fontWeight={'bold'} color={AppColors.secondary}>
          Add
        </Text>
        <AddIcon style={{ width: 18, height: 18 }} />
      </HStack>
    );
  }

  function renderContacts() {
    return (
      <SimpleGrid
        spacing={GRID_SPACING}
      >
        {contactField.fields.map(renderAddContactForm)}
      </SimpleGrid>
    );
  }
  return (
    <Modal size={'4xl'} isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay style={{ backgroundColor: '#001A41' }} />
      <ModalContent mx={4} px={8}>
        <ModalHeader fontFamily={FONT_FAMILY.baiJamurjee} textAlign={'center'}>
          Edit Account Contact
        </ModalHeader>
        <Box
          style={{
            zIndex: '1',
          }}
          position={'absolute'}
          top={-10}
          right={-3}
        >
          <Circle>
            <ModalCloseButton
              size={'sm'}
              style={{ color: AppColors.white }}
              backgroundColor={'#8894A6'}
              p={3}
              onClick={onClose}
              borderRadius={50}
            />
          </Circle>
        </Box>
        <ModalBody p={6}>
          <FormControl>
            <Box>
              <Box
                maxHeight={270}
                overflow="scroll"
                overflowX={'hidden'}
                ref={scrollContainerRef}
                sx={{
                  '&::-webkit-scrollbar': {
                    width: '4px',
                  },
                  '&::-webkit-scrollbar-track': {
                    boxShadow: 'inset 0 0 4px lightGrey',
                    width: '4px',
                    borderRadius: '4px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: 'grey',
                    borderRadius: '4px',
                  },
                }}
              >
                {renderContacts()}
              </Box>
              <Box>
                {renderAddIcon({
                  onClick: () => {
                    contactField.append(createNewContact());
                    setSelectedCanUploadCheckBoxIndex(prev => [...prev, contactField.fields.length.toString()]);
                  },
                })}
              </Box>
            </Box>
          </FormControl>
        </ModalBody>
        <ModalFooter justifyContent={'center'} pt={0}>
          <Button
            mr={3}
            borderRadius={'full'}
            px={12}
            outline={`2px solid ${AppColors.secondary}`}
            _hover={{
              transition: 'all .1s ease',
              bgColor: AppColors.secondary,
              color: AppColors.white,
            }}
            onClick={onClose}
            variant={'outline'}
          >
            <Text fontWeight={'normal'} fontSize={'sm'}>
              Cancel
            </Text>
          </Button>
          <Button
            bgColor={AppColors.primary}
            borderRadius={'full'}
            px={12}
            outline={`2px solid ${AppColors.primary}`}
            color={AppColors.white}
            _hover={{
              transition: 'all .1s ease',
              bgColor: AppColors.white,
              color: AppColors.primary,
            }}
            onClick={handleSubmit(submitAddAccount)}
            isDisabled={isUpdating}
          >
            <Text fontSize={'sm'}>{isUpdating ? "Updating..." : "Update"}</Text>
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
export { EditAccountContact };